export enum SkuStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'

  }